<div class="relative">
  <!--<div class="col-2 viewBy-filter">
    <div class="field">
      <label>View By</label>
      <p-dropdown [(ngModel)]="selectPatientSubmissionOptions" [options]="patientSubmissionDropdown" (ngModelChange)="routeTo(selectPatientSubmissionOptions)"></p-dropdown>
    </div>
  </div>-->
  <div class="align-items-center flex justify-content-start" *ngIf="selectPatientSubmissionOptions === patientSubmissionDropdown[1].value">
    <div class="col-4">
      <div class="field">
        <ng-container>
          <label>Patient</label>
          <div class="p-inputgroup table-search-wrapper">
            <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg" alt="search.svg" /></span>
            <input
              class="table-search-field w-full"
              type="text"
              [(ngModel)]="searchPatient"
              [placeholder]="adminRoles() ? searchPatientById : searchPatientByNameOrMrn"
              (ngModelChange)="this.search.next($event)"
            />
          </div>
        </ng-container>
      </div>
    </div>
    <div class="col-3">
      <div class="field">
        <ng-container>
          <label>Case Manager</label>
          <div class="p-inputgroup table-search-wrapper">
            <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg" alt="search.svg" /></span>
            <input
              class="table-search-field w-full"
              type="text"
              [(ngModel)]="searchByCaseManager"
              [placeholder]="searchByCaseManagerPlaceHolder"
              (ngModelChange)="this.search.next($event)"
            />
          </div>
        </ng-container>
      </div>
    </div>
    <div class="col-3">
      <div class="field" *ngIf="selectPatientSubmissionOptions === patientSubmissionDropdown[1].value">
        <label>Date</label>
        <div class="p-inputgroup table-calendar-wrapper">
          <span class="p-inputgroup-addon"><img src="assets/images/calendar.svg" alt="calendar.svg" /></span>
          <p-calendar
            class="w-full"
            dateFormat="{{ datePickerFormat }}"
            ngDefaultControl
            placeholder="{{ datePickerPlaceholder }}"
            [(ngModel)]="rangeDates"
            selectionMode="range"
            [readonlyInput]="true"
            inputId="range"
            (ngModelChange)="selectVisitDate()"
            (onClear)="onCalendarClear()"
          ></p-calendar>
          <button *ngIf="rangeDates != null" (click)="onCalendarClear()" class="clearBtn">
            <img src="assets/images/error.svg" alt="" />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div>
    <!-- Patients listing -->
    <ng-container *ngIf="selectPatientSubmissionOptions === patientSubmissionDropdown[1].value">
      <div class="table-wrapper">
        <div class="table-header">
          <div class="align-items-center flex">
            <div>
              <button
                pButton
                pRipple
                type="button"
                [disabled]="loading"
                class="p-button-rounded p-button-text reload-btn"
                (click)="getPatientWithSubmissions()"
              ></button>
            </div>
            <h2>{{ patientSubmissionDropdown[1].label }}</h2>
            <div class="user-label">
              <img src="../../assets/images/patient_user.svg" alt="Patients" />
              <span>{{ totalPatient }}</span>
            </div>
          </div>
          <div>
            <p-button
              *ngIf="
                currentAgency.role == roleID.AgencyAdmin || currentAgency.role == roleID.CaseManager || currentAgency.role == roleID.OfficeWorker
              "
              (click)="createPatientForm()"
              label="Add Patient"
              styleClass="button-sm add-icon"
            ></p-button>
          </div>
        </div>
        <p-table #dt [value]="patients" [(selection)]="selectedPatients" dataKey="id" styleClass="submison-patient-tbl">
          <ng-template pTemplate="header">
            <tr class="gc-table-filter">
              <th id="patientSubmison" class="col-2">Patient</th>
              <th id="caseManagerSubmison" class="col-2">
                <div class="flex align-items-center gap-2">
                  <span>Case Manager</span>
                  <div class="filterClass">
                    <img
                      class="w-16"
                      *ngIf="!selectedCaseManagerName || !selectedCaseManagerName.length"
                      (click)="caseManagerDropdown.show()"
                      src="assets/images/filter-outline.svg"
                    />
                    <img
                      class="w-18"
                      *ngIf="selectedCaseManagerName && selectedCaseManagerName.length && selectedCaseManagerName.length > 0"
                      (click)="caseManagerDropdown.show()"
                      src="assets/images/filter-filled.svg"
                    />
                    <p-multiSelect
                      #caseManagerDropdown
                      (onPanelShow)="sortSelectedValues()"
                      (onChange)="onSelectCaseManagerFilter()"
                      [(ngModel)]="selectedCaseManagerName"
                      [options]="caseManagerFilter"
                      appendTo="body"
                      optionLabel="label"
                      optionValue="value"
                      styleClass="typeMulitselect-dd"
                    >
                      <ng-template pTemplate="header"
                        ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedCaseManagerName)"
                          ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                      ></ng-template>
                    </p-multiSelect>
                  </div>
                </div>
              </th>
              <th id="lastUpdatedSubmison" class="col-2">Last Updated</th>
              <th id="createdBySubmison" class="col-2">
                <div class="flex align-items-center gap-2">
                  <span>Created By</span>
                  <div class="filterClass">
                    <img
                      class="w-16"
                      *ngIf="!selectedCreatedByUserName || !selectedCreatedByUserName.length"
                      (click)="dropdown.show()"
                      src="assets/images/filter-outline.svg"
                    />
                    <img
                      class="w-18"
                      *ngIf="selectedCreatedByUserName && selectedCreatedByUserName.length && selectedCreatedByUserName.length > 0"
                      (click)="dropdown.show()"
                      src="assets/images/filter-filled.svg"
                    />
                    <p-multiSelect
                      #dropdown
                      (onPanelShow)="sortSelectedValues()"
                      (onChange)="onSelectedCreatedByUserName()"
                      [(ngModel)]="selectedCreatedByUserName"
                      [options]="createdByFilterNames"
                      appendTo="body"
                      optionLabel="label"
                      optionValue="value"
                      styleClass="typeMulitselect-dd"
                    >
                      <ng-template pTemplate="header"
                        ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedCreatedByUserName)"
                          ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                      ></ng-template>
                    </p-multiSelect>
                  </div>
                </div>
              </th>
              <th id="createdSubmison" class="col-2" pSortableColumn="createdAt" (click)="changeSortOrder()">
                Created At
                <p-sortIcon field="createdAt"></p-sortIcon>
              </th>
              <th id="agencySubmison" class="w-11rem" *ngIf="currentUser.is_super_admin">
                <div class="flex align-items-center gap-2">
                  <span>Agency</span>
                  <div class="filterClass dd-align-right">
                    <img
                      class="w-16"
                      *ngIf="!selectedAgency || !selectedAgency.length"
                      (click)="dropdownAgency.show()"
                      src="assets/images/filter-outline.svg"
                    />
                    <img
                      class="w-18"
                      *ngIf="selectedAgency && selectedAgency.length && selectedAgency.length > 0"
                      (click)="dropdownAgency.show()"
                      src="assets/images/filter-filled.svg"
                    />
                    <p-multiSelect
                      #dropdownAgency
                      (onPanelShow)="sortSelectedValues()"
                      (onChange)="onSelectAgency()"
                      [(ngModel)]="selectedAgency"
                      [options]="filteredAgencies"
                      appendTo="body"
                      optionLabel="label"
                      optionValue="value"
                      styleClass="typeMulitselect-dd"
                    >
                      <ng-template pTemplate="header"
                        ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedAgency)"
                          ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                      ></ng-template>
                    </p-multiSelect>
                  </div>
                </div>
              </th>
              <th
                id="optionsSubmison"
                class="w-11rem"
                *ngIf="
                  currentAgency.role == roleID.AgencyAdmin || currentAgency.role == roleID.CaseManager || currentAgency.role == roleID.OfficeWorker
                "
              ></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-patients let-rowIndex="rowIndex">
            <tr class="p-selectable-row submission-open cursor-pointer">
              <td (click)="patients.showEpisodeDetails = !patients.showEpisodeDetails; onPatientRowClick(rowIndex)">
                <span class="p-column-title">Patient</span>
                <div class="flex align-items-center gap-3">
                  <!--<div class="gc-agency-img" *ngIf="patients?.patient?.firstName">
                    <app-avatar [firstName]="patients?.patient?.firstName" [lastName]="patients?.patient?.lastName"></app-avatar>
                  </div>-->
                  <div *ngIf="adminRoles(); else elseBlock">
                    <p class="gc-agency-handle w-12rem">{{ patients.patient._id | truncate: defaultPatientIdLength }}</p>
                  </div>
                  <ng-template #elseBlock>
                    <div class="">
                      <p class="gc-agency-name" *ngIf="patients?.patient?.patientName">
                        {{ patients?.patient?.patientName | removeHtml | truncate: defaultMrnLength }}
                      </p>
                      <p class="gc-agency-handle">{{ patients.patient.mrn | removeHtml | truncate: defaultMrnLength   }}</p>
                    </div>
                    <div class="" *ngIf="currentAgency.role === RoleID.AgencyAdmin; else elseBlock">
                      <span
                        tooltipStyleClass="eSocMRNToolTip"
                        class="tooltip-icon"
                        [escape]="false"
                        pTooltip="
                            <b>IOH ID:</b>  {{ patients.patient?._id }}<br>
                            <b>MRN:</b> {{ patients.patient?.mrn | removeHtml }}<br>
                            <b>First Name:</b> {{ patients.patient?.firstName | removeHtml }}<br>
                            <b>Last Name:</b> {{ patients.patient?.lastName | removeHtml }}<br>
                            <b>Middle Initial:</b> {{ patients.patient?.middleInitial | removeHtml }}<br>
                            <b>Location:</b> {{ patients.patient?.location }}<br>
                            <b>Team:</b> {{ patients.patient?.team }}<br>
                            <b>Branch:</b> {{ patients.patient?.branch }}<br>
                            <b>ICD Codes:</b> {{ patients.patient?.icdCodes }}<br>
                            <b>Group:</b> {{ patients.patient?.group | removeHtml }}<br>
                            <b>Payor Sources:</b> {{ patients.patient?.payorSources }}<br>
                            <b>Referencing Physician:</b> {{ patients.patient?.referencingPhysician }}<br>
                            <b>Admission Coordinator:</b> {{ patients.patient?.admissionCoordinator }}<br>
                            <b>CEFSClaim Benefit Period Date:</b> {{ patients.patient?.CEFSClaimBenefitPeriodDate }}<br>
                            <b>CEFSClaim Order:</b> {{ patients.patient?.CEFSClaimOrder }}<br>
                            <b>Contact Info:</b><br>
                                  <b>&nbsp &nbsp Email:</b> {{ patients.patient?.contactInfo?.email }}<br>
                                  <b>&nbsp &nbsp Phone:</b> {{ patients.patient?.contactInfo?.phone }}<br>
                                  <b>&nbsp &nbsp Preferred Option:</b> {{ patients.patient?.contactInfo?.preferredOption }}<br>
                            <b>DOB:</b> {{ patients.patient?.dob }}<br>
                            <b>Case Manager First Name:</b> {{ patients.patient?.CaseManagerFirstName | removeHtml }}<br>
                            <b>Case Manager Last Name:</b> {{ patients.patient?.CaseManagerLastName | removeHtml }} "
                      >
                        <img src="assets/images/exclamation.svg" alt="exclamation.svg" />
                      </span>
                    </div>
                    <ng-template #elseBlock>
                      <div class="">
                        <span
                          tooltipStyleClass="eSocMRNToolTip"
                          class="tooltip-icon"
                          [escape]="false"
                          pTooltip="
                              <b>IOH ID:</b>  {{ patients.patient?._id }}<br>
                              <b>MRN:</b> {{ patients.patient?.mrn | removeHtml}}<br>
                              <b>Created:</b> {{ patients.patient?.createdAt | customDate }}"
                        >
                          <img src="assets/images/exclamation.svg" alt="exclamation.svg" />
                        </span>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </td>
              <td (click)="patients.showEpisodeDetails = !patients.showEpisodeDetails; onPatientRowClick(rowIndex)">
                <span class="image-text"
                  >{{ patients.patient.CaseManagerFirstName ? patients.patient.CaseManagerFirstName : '' | removeHtml}}
                  {{ patients.patient.CaseManagerLastName ? patients.patient.CaseManagerLastName : '' | removeHtml }}</span
                >
              </td>
              <td (click)="patients.showEpisodeDetails = !patients.showEpisodeDetails; onPatientRowClick(rowIndex)">
                <!--                <span class="image-text">{{patients.patient?.modifiedAt ? ( currentUser.is_super_admin? (patients.patient?.modifiedAt  | customDate) : (patients.patient?.modifiedAt  | date: dateFormat) ) : ''}}</span>-->
                <span class="image-test">{{ patients.patient?.modifiedAt | dateElapsedTime }}</span>
              </td>
              <td (click)="patients.showEpisodeDetails = !patients.showEpisodeDetails; onPatientRowClick(rowIndex)">
                <div>
                  <p class="image-text">
                    {{
                      (patients.users?.firstName ? patients.users?.firstName : '') + ' ' + (patients.users?.lastName ? patients.users?.lastName : '') | removeHtml
                    }}
                  </p>
                  <p class="gc-agency-handle">{{ patients.users?.defaultRole ? '(' + RoleEnum[patients.users?.defaultRole] + ')' : '' }}</p>
                </div>
              </td>
              <td (click)="patients.showEpisodeDetails = !patients.showEpisodeDetails; onPatientRowClick(rowIndex)">
                <span class="p-column-title">Created</span>
                <span class="image-text">{{ patients.patient?.createdAt ? (patients.patient?.createdAt | date: dateFormat) : '' }}</span>
              </td>
              <td
                *ngIf="currentUser.is_super_admin"
                (click)="patients.showEpisodeDetails = !patients.showEpisodeDetails; onPatientRowClick(rowIndex)"
              >
                <span class="p-column-title">View</span>
                <mat-icon>{{ patients.showEpisodeDetails ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
              </td>
              <td
                *ngIf="
                  currentAgency.role == roleID.AgencyAdmin || currentAgency.role == roleID.CaseManager || currentAgency.role == roleID.OfficeWorker
                "
                class="text-right"
              >
                <button
                  *ngIf="patients.patient?.platform == 'web'"
                  [matMenuTriggerFor]="menu"
                  aria-label="Example icon-button with a menu"
                  mat-icon-button
                >
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button (click)="onEditPatient(rowIndex)" mat-menu-item>
                    <span class="mat-opi-icon">
                      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 7V12.75C12 12.9142 11.9677 13.0767 11.9048 13.2284C11.842 13.38 11.75 13.5178 11.6339 13.6339C11.5178 13.75 11.38 13.842 11.2284 13.9048C11.0767 13.9677 10.9142 14 10.75 14H3.25C2.91848 14 2.60054 13.8683 2.36612 13.6339C2.1317 13.3995 2 13.0815 2 12.75V5.25C2 4.91848 2.1317 4.60054 2.36612 4.36612C2.60054 4.1317 2.91848 4 3.25 4H8.48375"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.373 1.66418C14.3274 1.614 14.272 1.57361 14.2103 1.54543C14.1486 1.51726 14.0818 1.50189 14.014 1.50025C13.9461 1.49862 13.8787 1.51075 13.8157 1.53592C13.7527 1.56108 13.6954 1.59876 13.6474 1.64668L13.2608 2.03136C13.214 2.07824 13.1877 2.14181 13.1877 2.20808C13.1877 2.27436 13.214 2.33792 13.2608 2.3848L13.6152 2.73855C13.6385 2.76189 13.6661 2.78041 13.6965 2.79304C13.7269 2.80568 13.7595 2.81219 13.7924 2.81219C13.8253 2.81219 13.8579 2.80568 13.8884 2.79304C13.9188 2.78041 13.9464 2.76189 13.9696 2.73855L14.3465 2.36355C14.5371 2.17324 14.5549 1.86324 14.373 1.66418Z"
                        />
                        <path
                          d="M12.4792 2.81241L6.83798 8.44366C6.80378 8.47773 6.77892 8.52002 6.76579 8.56647L6.50486 9.34366C6.4986 9.36475 6.49816 9.38714 6.50357 9.40845C6.50899 9.42977 6.52005 9.44923 6.5356 9.46479C6.55116 9.48034 6.57062 9.49141 6.59194 9.49682C6.61326 9.50223 6.63564 9.50179 6.65673 9.49554L7.43329 9.2346C7.47975 9.22148 7.52204 9.19662 7.55611 9.16241L13.1874 3.52054C13.2395 3.46788 13.2687 3.3968 13.2687 3.32273C13.2687 3.24865 13.2395 3.17757 13.1874 3.12491L12.8764 2.81241C12.8237 2.75984 12.7523 2.73032 12.6778 2.73032C12.6034 2.73032 12.5319 2.75984 12.4792 2.81241Z"
                        />
                      </svg>
                    </span>
                    <span>Edit</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
            <ng-container *ngIf="patients.showEpisodeDetails">
              <ng-container
                [ngTemplateOutletContext]="{
                  episodeDetails: patients.patient.episodes,
                  firstName: patients.patient.firstName,
                  lastName: patients.patient.lastName,
                  mrn: patients.patient.mrn,
                  dob: patients.patient.dob,
                  totalErrorAndWarnings: patients.patient.totalErrors + patients.patient.totalWarnings,
                  picture: patients.patient.picture,
                  contactInfo: patients.patient.contactInfo,
                  patientId: patients.patient._id,
                  icdCodes: patients.patient.icdCodes
                }"
                [ngTemplateOutlet]="episodeListing"
              >
              </ng-container>
            </ng-container>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" style="text-align: center">
                <span>
                  <em class="pi pi-exclamation-circle mr-2"></em>
                  No Patient found
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div>
          <p-paginator
            styleClass="gc-paginator"
            #paginator
            [rows]="noOfRecordPerRow"
            [totalRecords]="totalPatient"
            (onPageChange)="paginate($event)"
            [rowsPerPageOptions]="rowsPerPageOptions"
          ></p-paginator>
        </div>
      </div>
    </ng-container>
    <!-- Episodes listing -->
    <!--    <ng-container *ngIf="selectPatientSubmissionOptions === patientSubmissionDropdown[0].value">-->
    <!--      <app-episode></app-episode>-->
    <!--    </ng-container>-->
    <!--    &lt;!&ndash; Visits listing &ndash;&gt;-->
    <!--    <ng-container *ngIf="selectPatientSubmissionOptions === patientSubmissionDropdown[2].value">-->
    <!--      <app-visit></app-visit>-->
    <!--    </ng-container>-->
    <!--    &lt;!&ndash; Episodes listing &ndash;&gt;-->
    <!--    <ng-container *ngIf="selectPatientSubmissionOptions === patientSubmissionDropdown[3].value">-->
    <!--      <app-unmatched-visits></app-unmatched-visits>-->
    <!--    </ng-container>-->
  </div>
</div>

<!-- Episode Listing for click on patient -->
<ng-template
  #episodeListing
  let-episodeDetails="episodeDetails"
  let-rowIndex="rowIndex"
  let-patientId="patientId"
  let-firstName="firstName"
  let-lastName="lastName"
  let-mrn="mrn"
  let-dob="dob"
  let-totalErrorAndWarnings="totalErrorAndWarnings"
  let-picture="picture"
  ,
  let-contactInfo="contactInfo"
  ,
  let-icdCodes="icdCodes"
>
  <tr class="cursor-pointer">
    <td colspan="10" class="leftBoder-4">
      <p-table #dt [value]="episodeDetails" class="submissionDetails-table">
        <ng-template pTemplate="header">
          <tr>
            <th id="episodeNameEpisodes" class="col-2">Episode Name</th>
            <th id="noOfVisitEpisodes" class="col-1">No. of Visit</th>
            <th id="errorsAndWarningsEpisodes" class="col-1">Errors & Warnings</th>
            <th id="noOfDaysEpisodes" class="col-1">No. of Days</th>
            <th id="startDateEpisodes" class="col-2">Start Date</th>
            <th id="statusEpisodes" class="col-1">Status</th>
            <th id="optionsEpisodes" class="col-1"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-selectedPatientEpisode let-rowIndex="rowIndex">
          <tr
            class="p-selectable-row"
            (click)="selectedPatientEpisode.showSubmissionsDetails = !selectedPatientEpisode.showSubmissionsDetails; onEpisodeRowClick(rowIndex)"
          >
            <td>
              <span class="p-column-title">Episode Name</span>
              <div class="flex align-items-center gap-3">
                <div>
                  <span class="image-text">{{ selectedPatientEpisode?.episodeName }}</span>
                </div>
                <div class="">
                  <span
                    tooltipStyleClass="eSocMRNToolTip"
                    class="tooltip-icon"
                    [escape]="false"
                    pTooltip="Episode ID: {{ selectedPatientEpisode?._id }} "
                  >
                    <img src="assets/images/exclamation.svg" alt="exclamation.svg"
                  /></span>
                </div>
              </div>
            </td>
            <td>
              <span class="p-column-title">No. of Visit</span>
              <span class="image-text">{{ selectedPatientEpisode?.submissionCount }}</span>
            </td>
            <td>
              <span class="p-column-title">Errors & Warnings</span>
              <div *ngIf="selectedPatientEpisode?.totalAlertsErrors > 0 || selectedPatientEpisode?.totalAlertsWarnings > 0; else normalSection" class="flex gap-1">
                <div [class.errors-label]="selectedPatientEpisode?.totalAlertsErrors > 0"
                  [class.success-label]="selectedPatientEpisode?.totalAlertsErrors === 0"
                  >
                  {{ selectedPatientEpisode?.totalAlertsErrors }}
                </div>
                <div
                  [class.success-label]="selectedPatientEpisode?.totalAlertsWarnings === 0"
                  [class.warnings-label]="selectedPatientEpisode?.totalAlertsWarnings > 0"
                >
                  {{ selectedPatientEpisode?.totalAlertsWarnings }}
                </div>
              </div>
              <ng-template #normalSection>
                <div class="flex gap-1">
                <div
                  [class.errors-label]="selectedPatientEpisode?.totalEpisodeErrors > 0"
                  [class.success-label]="selectedPatientEpisode?.totalEpisodeErrors === 0"
                >
                  {{ selectedPatientEpisode?.totalEpisodeErrors }}
                </div>
                <div
                  [class.success-label]="selectedPatientEpisode?.totalEpisodeWarnings === 0"
                  [class.warnings-label]="selectedPatientEpisode?.totalEpisodeWarnings > 0"
                >
                  {{ selectedPatientEpisode?.totalEpisodeWarnings }}
                </div>
                </div>
              </ng-template>
            </td>
            <td>
              <span class="p-column-title">No. of Days</span>
              <div class="flex">
                <span class="image-text">{{ selectedPatientEpisode?.episodeCreatedAt | noOfDays }}</span>
                <!--                <span class="image-text">{{ selectedPatientEpisode.numberOfDays }}</span>-->
              </div>
            </td>
            <td>
              <span class="p-column-title">Start Date</span>
              <span class="image-text">{{ selectedPatientEpisode?.episodeCreatedAt | customDate }}</span>
            </td>
            <td>
              <span class="p-column-title">Status</span>
              <span class="image-text" [style.color]="submissionStatusColorEnum[statusColor(selectedPatientEpisode?.episodeStatus | lowercase)]">{{
                getLabelByValue(selectedPatientEpisode?.episodeStatus)
              }}</span>
            </td>
            <td>
              <!--              <span class="p-column-title">View</span>-->
              <!--              <mat-icon>{{ selectedPatientEpisode.showSubmissionsDetails ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>-->
            </td>
          </tr>
          <ng-container *ngIf="selectedPatientEpisode.showSubmissionsDetails">
            <ng-container
              [ngTemplateOutletContext]="{
                submissionDetails: selectedPatientEpisode.submissions,
                firstName: firstName,
                lastName: lastName,
                mrn: mrn,
                patientId: patientId,
                totalErrorAndWarnings: patientSubmission?.submissionErrorCount + patientSubmission?.submissionWarningCount,
                dob: dob,
                contactInfo: contactInfo,
                icdCodes: icdCodes
              }"
              [ngTemplateOutlet]="submissionListing"
            >
            </ng-container>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" style="text-align: center">
              <span>
                <em class="pi pi-exclamation-circle mr-2"></em>
                No Episode Found
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </td>
  </tr>
</ng-template>

<!-- Submission listing for open patient -->
<ng-template
  #submissionListing
  let-submissionDetails="submissionDetails"
  let-firstName="firstName"
  let-lastName="lastName"
  let-mrn="mrn"
  let-dob="dob"
  let-patientId="patientId"
  let-totalErrorAndWarnings="totalErrorAndWarnings"
  let-picture="picture"
  ,
  let-contactInfo="contactInfo"
  ,
  let-icdCodes="icdCodes"
>
  <tr class="cursor-pointer">
    <td colspan="10" class="episodeLeftBorder-4">
      <p-table #dt [value]="submissionDetails" class="submissionDetails-table">
        <ng-template pTemplate="header">
          <tr>
            <th id="submittedBy" class="col-1">Submitted By</th>
            <th id="visitType" class="col-1">Visit Type</th>
            <th id="visitDate" class="col-1">Visit Date</th>
            <th id="errorsAndWarning" class="col-1">Errors & Warnings</th>
            <ng-container *ngIf="allowAdminRoles">
              <th id="map" class="col-1">Map</th>
            </ng-container>
            <th id="lastDate" class="col-2">Last Date - Time</th>
            <th id="statusSubmission" class="col-1">Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-selectedPatientSubmission let-rowIndex="rowIndex">
          <tr
            class="p-selectable-row"
            (click)="
              openPatientSubmissionDetails(
                selectedPatientSubmission,
                dob,
                mrn,
                firstName,
                lastName,
                totalErrorAndWarnings,
                picture,
                rowIndex,
                contactInfo,
                patientId,
                icdCodes
              )
            "
          >
            <td>
              <div>
                <p class="gc-agency-name">{{ selectedPatientSubmission?.submittedBy ? selectedPatientSubmission?.submittedBy : '' | removeHtml }}</p>
                <p class="gc-agency-handle">
                  {{ selectedPatientSubmission?.submitterRole ? '( ' + RoleEnum[selectedPatientSubmission?.submitterRole] + ' )' : '' }}
                </p>
              </div>
            </td>
            <td>
              <span class="p-column-title">Visit Type</span>
              <span class="image-text">{{ selectedPatientSubmission?.visitType | removeHtml }}</span>
            </td>
            <td>
              <span class="p-column-title">Visit Date</span>
              <span class="image-text">{{ selectedPatientSubmission?.visitDate | date: dateFormat }}</span>
            </td>
            <td>
              <span class="p-column-title">Errors & Warnings</span>
              <div *ngIf="selectedPatientSubmission?.alertErrorCount > 0 || selectedPatientSubmission?.alertWarningCount > 0; else normalSection" class="flex gap-1">
                <div
                  [class.errors-label]="selectedPatientSubmission?.alertErrorCount> 0"
                  [class.success-label]="selectedPatientSubmission?.alertErrorCount === 0"
                >
                  {{ selectedPatientSubmission?.alertErrorCount }} Errors
                </div>
                <div
                  [class.success-label]="selectedPatientSubmission?.alertWarningCount === 0"
                  [class.warnings-label]="selectedPatientSubmission?.alertWarningCount > 0"
                >
                  {{ selectedPatientSubmission?.alertWarningCount }} Warnings
                </div>
                </div>

              <ng-template #normalSection>
                <div class="flex gap-1">
                  <div
                  [class.errors-label]="selectedPatientSubmission?.submissionErrorCount > 0"
                  [class.success-label]="selectedPatientSubmission?.submissionErrorCount === 0"
                >
                  {{ selectedPatientSubmission?.submissionErrorCount }}
                </div>
                <div
                  [class.success-label]="selectedPatientSubmission?.submissionWarningCount === 0"
                  [class.warnings-label]="selectedPatientSubmission?.submissionWarningCount > 0"
                >
                  {{ selectedPatientSubmission?.submissionWarningCount }}
                </div>
              </div>
             </ng-template>

            </td>
            <ng-container *ngIf="allowAdminRoles">
              <td>
                <span class="p-column-title">Google Map</span>
                <div>
                  <ng-container *ngIf="selectedPatientSubmission.latitude && selectedPatientSubmission.longitude; else notApplicableDiv">
                    <div
                      (click)="
                        $event.stopPropagation();
                        patientSubmission = selectedPatientSubmission;
                        showLocationDialog(selectedPatientSubmission.visitDate, selectedPatientSubmission.visitType)
                      "
                    >
                      <em class="pi pi-map-marker"></em>
                    </div>
                  </ng-container>
                  <ng-template #notApplicableDiv>
                    <div (click)="$event.stopPropagation()">Not Applicable</div>
                  </ng-template>
                </div>
              </td>
            </ng-container>
            <td>
              <span class="p-column-title">Submission Date - Time</span>
              <span class="image-text">{{ selectedPatientSubmission?.submissionDate | customDate }}</span>
            </td>
            <td>
              <span class="p-column-title">Status</span>
              <span class="image-text" [style.color]="submissionStatusColorEnum[statusColor(selectedPatientSubmission?.status | lowercase)]">{{
                getLabelByValue(selectedPatientSubmission?.status)
              }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" style="text-align: center">
              <span>
                <em class="pi pi-exclamation-circle mr-2"></em>
                No Submission found
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </td>
  </tr>
</ng-template>

<!-- //sidebar  -->
<p-sidebar class="sidebar-lg" position="right" [(visible)]="display" [showCloseIcon]="false" (onHide)="onSlideBarClose()">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <h2 class="gc-form-heading">Visit Details</h2>
        <span
          >[{{
            patientSubmission?.submissionDate
              ? (patientSubmission?.submissionDate | customDate)
              : (patientSubmission?.submissionData?.submissionDate | customDate)
          }}]</span
        >
        <span
          [style.color]="
            visitDetailColors[
              patientSubmission?.status ? getLabelByValue(patientSubmission?.status) : getLabelByValue(patientSubmission?.submissionData?.status)
            ]
          "
          >{{
            patientSubmission?.status ? getLabelByValue(patientSubmission?.status) : getLabelByValue(patientSubmission?.submissionData?.status)
          }}</span
        >
      </div>
      <div>
        <span (click)="onSlideBarClose()" class="cursor-pointer"><em class="pi pi-times"></em></span>
      </div>
    </div>
    <br />
    <br />
  </ng-template>
  <ng-template pTemplate="content">
    <app-visit-details
      [patientSubmission]="patientSubmission"
      (closeSideBar)="onSlideBarClose()"
      (eSOCUploadDisplay)="openeSOCUploadPopup()"
      (reloadPatientSubmission)="getPatientWithSubmissions()"
    ></app-visit-details>
  </ng-template>
</p-sidebar>
<app-esoc-upload
  *ngIf="eSOCUploadDisplay"
  [eSOCUploadDisplay]="eSOCUploadDisplay"
  [userId]="currentUser._id"
  [currentUserRole]="currentUser.currentUserRole"
  [patientSubmission]="patientSubmission"
  (eSocPopUpClose)="eSOCUploadPopupClose()"
  (eSockUploadListingRefresh)="refreshListing()"
>
</app-esoc-upload>
<p-dialog [(visible)]="locationPopupDisplay" [modal]="true" [style]="{ width: '400px' }" [dismissableMask]="true">
  <ng-template pTemplate="header">
    <span>Visit Type: {{ selectedVisitType }} - Visit Date: {{ selectedVisitDates | customDate }}</span>
  </ng-template>
  <!-- <p-gmap [options]="options" *ngIf="locationPopupDisplay" [overlays]="overlays" [style]="{ width: '100%', height: '320px' }"></p-gmap> -->
  <!-- Google Maps component removed - GMapModule not available in PrimeNG 16+ -->
</p-dialog>

<p-sidebar (onHide)="onPatientSlideBarClose()" [(visible)]="displayPatient" [showCloseIcon]="false" position="right">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 class="gc-form-heading">
        <span *ngIf="isPatientEditForm; else addform">Update Patient</span>
        <ng-template #addform>Add Patient</ng-template>
      </h2>
      <span (click)="onPatientSlideBarClose()" class="cursor-pointer"><em class="pi pi-times"></em></span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <form #patientForm="ngForm">
      <div class="popup-wrapper">
        <div class="gc-form-section">
          <div class="gc-form-section-heading">
            <h3>Patient</h3>
          </div>
          <div class="sidebar-form">
            <div class="grid p-fluid">
              <div class="col-12">
                <div class="flex align-items-center justify-content-between">
                  <label>MRN<span class="red">*</span></label>
                </div>
                <span>
                  <input
                    [(ngModel)]="eSockSubmissionForm.mrn"
                    [required]="true"
                    [disabled]="isPatientEditForm"
                    [ngClass]="isPatientEditForm ? 'opacity7' : ''"
                    class="p-inputtext"
                    id="mrn"
                    name="mrn"
                    pInputText
                    placeholder="MRN"
                    type="text"
                    pattern="[a-zA-Z0-9]+"
                    minlength="6"
                  />
                </span>
              </div>
            </div>
            <div class="align-name-fields">
              <div class="grid p-fluid">
                <div class="col-12">
                  <div class="flex align-items-center justify-content-between">
                    <label>First Name<span class="red">*</span></label>
                  </div>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"><img src="../../../assets/images/input-user.svg" alt="input-user.svg" /></span>
                    <input
                      [(ngModel)]="eSockSubmissionForm.firstName"
                      [required]="true"
                      class="p-inputtext"
                      id="firstName"
                      name="firstName"
                      pInputText
                      placeholder="First Name"
                      type="text"
                    />
                  </span>
                </div>
              </div>
              <div class="grid p-fluid">
                <div class="col-12">
                  <div class="flex align-items-center justify-content-between">
                    <label>Middle Initial</label>
                  </div>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"><img src="../../../assets/images/input-user.svg" alt="input-user.svg" /></span>
                    <input
                      [(ngModel)]="eSockSubmissionForm.middleInitial"
                      class="p-inputtext"
                      id="middleInitial"
                      name="middleInitial"
                      pInputText
                      placeholder="Middle Initial"
                      type="text"
                    />
                  </span>
                </div>
              </div>
              <div class="grid p-fluid">
                <div class="col-12">
                  <div class="flex align-items-center justify-content-between">
                    <label>Last Name<span class="red">*</span></label>
                  </div>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"><img src="../../../assets/images/input-user.svg" alt="input-user.svg" /></span>
                    <input
                      [(ngModel)]="eSockSubmissionForm.lastName"
                      class="p-inputtext"
                      id="lastName"
                      name="lastName"
                      required
                      minlength="2"
                      pInputText
                      placeholder="Last Name"
                      type="text"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gc-form-section">
          <div class="gc-form-section-heading">
            <h3>Preferred Method</h3>
          </div>
          <div class="sidebar-form">
            <div class="grid p-fluid">
              <div class="col-12">
                <div class="flex align-items-center justify-content-between">
                  <label>DOB<span class="red">*</span></label>
                </div>
                <span class="p-input-icon-left">
                  <span class="gc-input-icon">
                    <img src="assets/images/calendar.svg" alt="calendar.svg" />
                  </span>

                  <p-calendar
                    #dob="ngModel"
                    [(ngModel)]="eSockSubmissionForm.dob"
                    [required]="true"
                    class="w-full disable-calendar"
                    [class.dob-error]="dob.invalid && dob.touched"
                    dateFormat="{{ dobDateFormat }}"
                    name="dob"
                    placeholder="mm/dd/yyyy"
                    dateMask="99/99/9999"
                  ></p-calendar>
                </span>
              </div>
            </div>
            <div class="grid p-fluid">
              <div class="col-12">
                <div class="flex align-items-center justify-content-between">
                  <label>Email<span *ngIf="eSockSubmissionForm?.email?.preferred" class="red">*</span></label>
                  <div class="flex align-items-center gap-2">
                    <p-checkbox
                      (onChange)="changeCheckboxValue()"
                      [(ngModel)]="eSockSubmissionForm.email.preferred"
                      [binary]="true"
                      inputId="email"
                      name="emailPrefferd"
                    ></p-checkbox>
                    <label>Send via Email</label>
                  </div>
                </div>
                <span class="p-input-icon-left">
                  <span class="gc-input-icon"><img src="../../assets/images/email-icon.svg" alt="email-icon.svg" /></span>
                  <input
                    [(ngModel)]="eSockSubmissionForm.email.email"
                    [required]="eSockSubmissionForm?.email?.preferred"
                    class="p-inputtext"
                    email
                    id="email"
                    name="email"
                    pInputText
                    placeholder="Email"
                    type="email"
                  />
                </span>
              </div>
            </div>
            <div class="grid p-fluid">
              <div class="col-12">
                <div class="flex align-items-center justify-content-between">
                  <label>Phone<span *ngIf="eSockSubmissionForm.phoneNumber.preferred" class="red">*</span></label>
                  <div class="flex align-items-center gap-2">
                    <p-checkbox
                      (onChange)="changeCheckboxValue()"
                      [(ngModel)]="eSockSubmissionForm.phoneNumber.preferred"
                      [binary]="true"
                      inputId="phone"
                      name="phonePreffered"
                    ></p-checkbox>
                    <label>Send via Phone</label>
                  </div>
                </div>
                <div class="flex gc-dialCode">
                  <p-dropdown  [(ngModel)]="eSockSubmissionForm.phoneNumber.countryCode"
                    [options]="countries"
                    name="countryCode"
                    optionLabel="dial_code"
                    optionValue="dial_code"
                  >
                    <!-- FIX 1: Add safe navigation in selectedItem template -->
                    <ng-template let-country pTemplate="selectedItem">
                      <ng-container *ngIf="country">
                        <span class="fi fi-{{ country.code?.toLowerCase() || 'us' }} countryflag"></span>
                        <span class="country-code"> {{ country?.dial_code || '+1' }}</span>
                      </ng-container>
                      <ng-container *ngIf="!country">
                        <span class="fi fi-us countryflag"></span>
                        <span class="country-code"> +1</span>
                      </ng-container>
                    </ng-template>

                    <!-- FIX 2: Add safe navigation in item template -->
                    <ng-template let-country pTemplate="item">
                      <ng-container *ngIf="country">
                        <span class="fi fi-{{ country.code?.toLowerCase() }} countryflag"></span>
                        <span class="country-code"> {{ country.dial_code }}</span>
                      </ng-container>
                    </ng-template>
                  </p-dropdown>
                  <p-inputMask
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="isPhoneNumberValid($event)"
                    [(ngModel)]="eSockSubmissionForm.phoneNumber.number"
                    aria-required="true"
                    class="w-full"
                    mask="999-999-9999"
                    name="phoneNumber"
                    placeholder="(XXX) XXX-XXXX"
                  ></p-inputMask>
                </div>
              </div>
            </div>
            <div class="grid p-fluid">
              <div class="col-12">
                <div class="flex align-items-center gap-2">
                  <p-checkbox [(ngModel)]="eSockSubmissionForm.consent" [binary]="true" name="myCheckbox" value="someValue"></p-checkbox>
                  <label>Yes! I agree to receive email or SMS</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-sidebar-footer button-container px-4">
        <button
          *ngIf="isPatientEditForm && currentAgency.role == roleID.AgencyAdmin"
          (click)="patientDeleteConfirmation()"
          class="btn-delete"
          label="Delete"
          pButton
        ></button>

        <button (click)="displayPatient = false" class="btn-cancel" pButton>Close</button>

        <button
          *ngIf="!isPatientEditForm"
          (click)="createPatient()"
          [disabled]="
            !isValidPhoneNumber ||
            !patientForm.valid ||
            !(
              (eSockSubmissionForm?.phoneNumber?.preferred && eSockSubmissionForm?.phoneNumber?.number) ||
              (eSockSubmissionForm?.email?.preferred && eSockSubmissionForm?.email?.email)
            )
          "
          class="p-button"
          pButton
        >
          Add
        </button>

        <button
          *ngIf="isPatientEditForm"
          (click)="patientUpdateConfirmation()"
          [disabled]="
            !isValidPhoneNumber ||
            !patientForm.valid ||
            !(
              (eSockSubmissionForm?.phoneNumber?.preferred && eSockSubmissionForm?.phoneNumber?.number) ||
              (eSockSubmissionForm?.email?.preferred && eSockSubmissionForm?.email?.email)
            )
          "
          label="Update"
          pButton
          type="submit"
          class="p-button"
        ></button>
      </div>
    </form>
  </ng-template>
</p-sidebar>

<p-dialog [(visible)]="showPatientCreationSuccessPopup" [style]="{ width: '320px' }" class="addUser-popup">
  <div class="flex align-items-center flex-column gap-3">
    <img src="../../../../assets/images/successful.gif" alt="successful.gif" class="w-12rem" />
    <h3 class="text-center">Congratulations!</h3>
    <p class="text-center">Congrats! email with username and temporary password sent!</p>
  </div>
</p-dialog>
